import React, { useEffect, useState } from 'react';
import colours from 'styles/colours';

export default function Spinner({size = 24, width = 3, colour}) {

    const spinnerColor = colour || colours.border.spinner.shadow;

    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRotation((prev) => (prev + 6) % 360); // Increment rotation by 6 degrees
        }, 16); // Roughly 60fps (16ms per frame)

        return () => clearInterval(interval);
    }, []);

    const spinnerStyle = {
        width: size,
        height: size,
        margin: 10,
        transformOrigin: 'center',
        borderWidth: width,
        borderStyle: 'solid',
        borderColor: colours.border.spinner.highlight,
        borderTopColor: spinnerColor,
        borderRadius: '50%',
        transform: `rotate(${rotation}deg)`,
    };

    return <div style={spinnerStyle}></div>;
}
